// src/components/IntroSection.js
import React from 'react';
import { Box, Typography, Grid, Card, CardContent, useMediaQuery, useTheme } from '@mui/material';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import CasinoIcon from '@mui/icons-material/Casino';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import LoopIcon from '@mui/icons-material/Loop';
import BuildIcon from '@mui/icons-material/Build';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const FeaturesSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const features = [
    { icon: <SportsEsportsIcon fontSize="large" />, title: '게임 전적', desc: '닉값하는 다양한 게임 전적 검색 기능' },
    { icon: <CasinoIcon fontSize="large" />, title: '도박 & 게임', desc: '많은 사용자가 재미있게 즐기는 다양한 도박' },
    { icon: <RestaurantMenuIcon fontSize="large" />, title: '급식 조회', desc: '내가 다니는 학교의 급식 확인 기능' },
    { icon: <LoopIcon fontSize="large" />, title: '랜덤 채팅', desc: '전적이 사용자들과의 랜덤 채팅(미출시)' },
    { icon: <BuildIcon fontSize="large" />, title: '커스텀 명령어', desc: '내 서버만의 커스텀 명령어로 자유롭게' },
    { icon: <MoreHorizIcon fontSize="large" />, title: '편의 기능', desc: '다양한 편의기능을 체험하세요' },
  ];

  return (
    <Box sx={{color: theme.palette.text.primary, py: 6, px: 2, textAlign: 'center', maxWidth:1300 }}>
      <Typography 
        variant="h4" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontSize: { xs: '1.8rem',sm:'2.5rem', md: '4em' },
          mb:{ xs: 4,sm:8, md: 10 },
          color: theme.palette.mode === 'light' ? '#7ab4f5' : theme.palette.text.primary,
          }}>
        다양한 기능들을 지금 체험해 보세요
      </Typography>

      <Grid
        container
        spacing={isMobile ? 5 : 10}
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(1, 1fr)',sm:'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },

        }}
      >
        {features.map((feature, idx) => (
          <Grid item key={idx}>
            <Card 
              sx={{
                bgcolor: '#2b52a1',
                height: {xs: '200px', sm:'100%', md:'100%'},
                borderRadius: 2,
                py: 3,
                maxWidth: 340,
                mx: 'auto',
                }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flex: 1,
                }}
              >
                <Box
                  sx={{
                    bgcolor: '#88a2d8',
                    borderRadius: '50%',
                    width: 60,
                    height: 60,
                    flexShrink: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mb: 2,
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography variant="h6" color="#ffffff" gutterBottomsx={{ fontWeight: 'bold' }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="#ccc" sx={{ px: 1 }}>
                  {feature.desc}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturesSection;
